import {
  Container,
  Header,
  Segment,
  Grid,
  Icon,
  Image,
} from "semantic-ui-react";

export const Publication = (props) => {
  return (
    <Segment id="publication" vertical padded="very">
      <Container textAlign="center">
        <Grid stackable>
          <Grid.Row verticalAlign="middle">
            <Grid.Column width={6}>
              <Image src="./paper.jpg" fluid />
            </Grid.Column>
            <Grid.Column width={10}>
              <Header as="h2" textAlign="left">
                Panoptic Narrative Grounding
                <Header.Subheader>
                  C. González, N. Ayobi, I. Hernández, J. Hernández, J.
                  Pont-Tuset and P. Arbeláez
                </Header.Subheader>
                <Header.Subheader>ICCV 2021 Oral Presentation</Header.Subheader>
              </Header>
              <p style={{ textAlign: "justify" }}>
                This paper proposes Panoptic Narrative Grounding, a spatially
                fine and general formulation of the natural language visual
                grounding problem. We establish an experimental framework for
                the study of this new task, including new ground truth and
                metrics, and we propose a strong baseline method to serve as
                stepping stone for future work. We exploit the intrinsic
                semantic richness in an image by including panoptic categories,
                and we approach visual grounding at a fine-grained level by
                using segmentations. In terms of ground truth, we propose an
                algorithm to automatically transfer Localized Narratives
                annotations to specific regions in the panoptic segmentations of
                the MS COCO dataset. To guarantee the quality of our
                annotations, we take advantage of the semantic structure
                contained in WordNet to exclusively incorporate noun phrases
                that are grounded to a meaningfully related panoptic
                segmentation region. The proposed baseline achieves a
                performance of 55.4 absolute Average Recall points. This result
                is a suitable foundation to push the envelope further in the
                development of methods for Panoptic Narrative Grounding.
              </p>
              <Grid columns={2} divided>
                <Grid.Row>
                  <Grid.Column>
                    <a href="https://arxiv.org/abs/2109.04988" target="_blank">
                      <Icon name="file pdf" size="large" />
                      PDF
                    </a>
                  </Grid.Column>
                  <Grid.Column>
                    <a
                      href="https://lambda004.uniandes.edu.co/panoptic-narrative-grounding/BibTex.txt"
                      target="_blank"
                    >
                      <Icon name="book" size="large" />
                      BibTeX
                    </a>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    </Segment>
  );
};
